import * as React from "react";

const TechnicianUser = (props) => (
    <svg
        width={68}
        height={78}
        viewBox="0 0 68 78"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <circle cx={34} cy={34} r={33} fill="white" />
        <circle cx={34} cy={34} r={30} fill="#DBE5EE" />
        <path
            d="M55.5 55L51 60L46.5 62.5C44.5 54 35.4 52.9 35 52.5C34.6 52.1 40 48.5 37.5 43C36.5 43.1667 33.3394 38.5762 35.5 38C43 36 40.5 19.5 35.5 17.5L38 17L41.5 18.5L44 24L44.5 25.5V35.5L43 39L41 41.5V45L42.5 47.5L47 48L52 49.5L55.5 55Z"
            fill="white"
        />
        <path
            d="M41 41.5C41.0001 43.5792 40.4496 47.7663 44.109 48.099C48.6833 48.5148 53.2574 48.099 54.505 55.1683"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M29.1386 41.4456C29.1386 43.5248 29.4713 47.7663 25.8119 48.099C21.2376 48.5149 16.2475 48.099 15 56"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M44.7724 29.802C44.7724 33.6325 44.1544 36.9355 42.6469 39.2544C41.1887 41.4973 38.8204 42.9406 34.9605 42.9406C31.3236 42.9406 28.9412 41.5082 27.4223 39.2426C25.8625 36.916 25.1486 33.6084 25.1486 29.802C25.1486 25.9725 25.7764 22.7623 27.2839 20.533C28.742 18.3767 31.1179 17 35.0001 17C38.0566 17 40.1122 17.6464 41.5195 18.8252C42.9263 20.0037 43.8417 21.8454 44.3361 24.5743C44.6393 26.2471 44.7724 28.0231 44.7724 29.802Z"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M31 36C31 36 31.8889 38 35 38C38.1111 38 39 36 39 36"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M34.9605 52.5002L28.4753 47.2673L26 52.5002H34.9605ZM34.9605 52.5002L41.5 46.5002L43.5 52.5002H34.9605ZM34.9605 52.5002V55.1683"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M44.1089 35.6238C44.1089 35.6238 47.4356 35.6242 47.4356 31.7075C47.4356 27.7908 45.1069 28.1471 45.1069 28.1471"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M25.8119 35.6238C25.8119 35.6238 22.4851 35.6242 22.4851 31.7075C22.4851 27.7908 24.8139 28.1471 24.8139 28.1471"
            stroke="#333F50"
            strokeWidth={2}
        />
        <circle cx={34} cy={34} r={33} stroke="#333F50" strokeWidth={2} />
        <circle
            cx={35}
            cy={65}
            r={12}
            fill="#DBE4EE"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path
            d="M46 65C46 71.0751 41.0751 76 35 76C35 76 41.2857 71.0751 41.2857 65C41.2857 58.9249 35 54 35 54C41.0751 54 46 58.9249 46 65Z"
            fill="white"
        />
        <path
            d="M42.986 61.4028C42.9752 61.2782 42.8929 61.1711 42.7751 61.1284C42.6571 61.0855 42.525 61.1147 42.4363 61.203L40.6199 63.0125L38.6062 62.3773L37.9686 60.3712L39.7851 58.5617C39.874 58.4732 39.903 58.3416 39.8601 58.2242C39.8169 58.1066 39.7097 58.0247 39.5843 58.0139C38.4812 57.9192 37.4003 58.3116 36.6188 59.0902C35.5485 60.1566 35.2651 61.7138 35.767 63.0411C35.7121 63.0872 35.658 63.1359 35.6046 63.1886L29.5414 68.8884C29.5392 68.8904 29.5371 68.8927 29.5348 68.8947C28.8217 69.6051 28.8217 70.761 29.5348 71.4715C30.248 72.1819 31.3997 72.1733 32.1127 71.4629C32.1157 71.46 32.1186 71.4571 32.1214 71.454L37.7928 65.3665C37.8445 65.3148 37.8925 65.2606 37.9378 65.2051C39.2704 65.706 40.8345 65.4243 41.9058 64.3572C42.6871 63.5785 43.0812 62.5016 42.986 61.4028ZM31.199 70.7041C30.9362 70.9658 30.5107 70.9657 30.2479 70.7041C29.9853 70.4427 29.9853 70.0184 30.2479 69.7568C30.5107 69.4953 30.9362 69.4953 31.199 69.7568C31.4616 70.0184 31.4616 70.4427 31.199 70.7041Z"
            fill="#333F50"
        />
        <rect
            x={27}
            y={27}
            width={6}
            height={6}
            rx={3}
            fill="white"
            stroke="#333F50"
            strokeWidth={2}
        />
        <path d="M33.5 30H36.5" stroke="#333F50" />
        <rect
            x={37}
            y={27}
            width={6}
            height={6}
            rx={3}
            fill="white"
            stroke="#333F50"
            strokeWidth={2}
        />
    </svg>
);

export default TechnicianUser;
